export const SNOWPACK_PUBLIC_API_URL = "https://app.songtek.net/song/analysis/ThermalStep";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;